import createIcon from '../../createIcon';

/**
 * @component @name Bookmarks
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMThMMjEgMTlWM0MyMSAxLjkgMjAuMSAxIDE5IDFIOC45OUM3Ljg5IDEgNyAxLjkgNyAzSDE3QzE4LjEgMyAxOSAzLjkgMTkgNVYxOFpNMTUgNUg1QzMuOSA1IDMgNS45IDMgN1YyM0wxMCAyMEwxNyAyM1Y3QzE3IDUuOSAxNi4xIDUgMTUgNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bookmarks = createIcon('Bookmarks', [
  [
    'path',
    {
      d: 'M19 18L21 19V3C21 1.9 20.1 1 19 1H8.99C7.89 1 7 1.9 7 3H17C18.1 3 19 3.9 19 5V18ZM15 5H5C3.9 5 3 5.9 3 7V23L10 20L17 23V7C17 5.9 16.1 5 15 5Z',
      key: '1xsx3d',
    },
  ],
]);

export default Bookmarks;
